export enum InterventionType {
	SOCIAL_WORK = 0,
	MEDICAL = 1,
    MENTAL_HEALTH = 2,
    DEVELOPMENT_PEDIA = 3,
	LEGAL = 4,
    TELECONSULTATION = 5,
    TELEPSYCHIATRY = 6,
	ADMIN = 7,
}